import React from 'react';
import { ShoppingCart } from 'lucide-react';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  isDirectCheckout?: boolean;
}
export function Button({
  children,
  onClick,
  href,
  className = '',
  isDirectCheckout = false
}: ButtonProps) {
  const checkoutUrl = 'https://pay.hotmart.com/S105109192C?checkoutMode=10';
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (!isDirectCheckout && href?.startsWith('#')) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    if (onClick) onClick();
  };
  const targetHref = isDirectCheckout ? checkoutUrl : href;
  const baseClasses = 'group relative inline-flex items-center justify-center gap-3 w-full sm:w-auto px-8 py-5 text-xl font-bold text-white bg-brand-green hover:bg-brand-greenHover rounded-xl shadow-[0_0_30px_rgba(34,197,94,0.4)] hover:shadow-[0_0_40px_rgba(34,197,94,0.6)] transition-all duration-300 transform hover:-translate-y-1 animate-pulse-fast overflow-hidden';
  if (targetHref) {
    return <a href={targetHref} onClick={handleClick} className={`${baseClasses} ${className}`} data-id="element-12">
        <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out" data-id="element-13" />
        <ShoppingCart className="w-6 h-6 relative z-10" data-id="element-14" />
        <span className="relative z-10" data-id="element-15">{children}</span>
      </a>;
  }
  return <button onClick={handleClick} className={`${baseClasses} ${className}`} data-id="element-16">
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out" data-id="element-17" />
      <ShoppingCart className="w-6 h-6 relative z-10" data-id="element-18" />
      <span className="relative z-10" data-id="element-19">{children}</span>
    </button>;
}